<template>
  <article :class="$style['c-grid-card-section-card']">
    <h3 :class="$style['c-grid-card-section-card__title']">
      {{ utils.sc.getFieldValue(card, 'title', '') }}
    </h3>
    <p :class="$style['c-grid-card-section-card__desc']">
      {{ utils.sc.getFieldValue(card, 'description', '') }}
    </p>
    <div :class="$style['c-grid-card-section-card__link']">
      <SiteButton
        :fields="buttonFields"
        default-type="tertiary"
        size="small"
        icon-name="arrow-right"
        icon-size="xxs"
      />
    </div>
    <div :class="$style['c-grid-card-section-card__decoration']">
      <SiteImage :field="utils.sc.getFieldObj(card, 'cardDecorationImage')" />
    </div>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SiteButton from '@/elements/SiteButton.vue';
import utils from '@/utils';

const props = defineProps<{
  card: any;
}>();

const buttonFields = computed(() => utils.sc.getFieldObj(props.card, 'button')?.fields || {});
</script>

<style module lang="scss">
.c-grid-card-section-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 390px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 8px rgba(116, 116, 116, 0.1);
  padding: 40px 24px;
  gap: 8px;
  overflow: hidden;
}

.c-grid-card-section-card__title {
  margin: 0;
  color: #0b1024;
  font-size: clamp(13px, 1vw, 18px);
  line-height: 1.3;
  font-weight: 700;
}

.c-grid-card-section-card__desc {
  margin: 6px 0 0;
  color: #4a4f62;
  font-size: clamp(11px, 0.84vw, 14px);
  line-height: 1.35;
}

.c-grid-card-section-card__link {
  margin-top: 10px;
  display: inline-flex;
}

.c-grid-card-section-card__link :global(.e-site-button) {
  min-height: 28px;
  font-size: clamp(11px, 0.86vw, 14px);
  font-weight: 600;
}

.c-grid-card-section-card__decoration {
  position: absolute;
  left: -220px;
  bottom: -200px;
  width: 400px;
  height: 400px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: left bottom;
  }
}

@media (max-width: 768px) {
  .c-grid-card-section-card {
    min-height: 224px;
    padding: 10px 10px 42px;
    border-radius: 8px;
  }

  .c-grid-card-section-card__title {
    font-size: 12px;
  }

  .c-grid-card-section-card__desc {
    margin-top: 4px;
    font-size: 10px;
  }

  .c-grid-card-section-card__link {
    margin-top: 8px;
    font-size: 10px;
  }

  .c-grid-card-section-card__decoration {
    width: 54px;
    height: 44px;
  }
}
</style>
